// TODO: fix for accessibility
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';

const Trumbowyg = ({
  id = 'trumbowyg-editor',
  buttons = [
    ['strong', 'em', 'unorderedList'],
    ['link']
  ],
  btnsDef = {},
  semantic = true,
  resetCss = false,
  autogrow = false,
  value = '',
  disabled = false,
  label = null,
  onFocus = null,
  onBlur = null,
  onInit = null,
  onChange = null,
  onResize = null,
  onPaste = null,
  onOpenFullScreen = null,
  onCloseFullScreen = null,
  onClose = null,
  onKeyDown = null,
  readOnly = false,
  rows = 5,
  placeholder = '',
  plugins = {},
  spellCheck = false,
  svgPath = null,
  propRef = null,
  wrapperClass = null
}) => {
  const { useEffect, useRef } = React;

  const trumbowygRef = propRef || useRef(null);

  useEffect(() => {
    const $trumbowygRef = $(trumbowygRef.current);

    $trumbowygRef.trumbowyg({
      btns: buttons,
      btnsDef,
      semantic,
      resetCss,
      autogrow,
      plugins,
      svgPath,
      keyboardAccessible: true
    });

    if (onFocus) {
      $trumbowygRef.on('tbwfocus', onFocus);
    }

    if (onBlur) {
      $trumbowygRef.on('tbwblur', onBlur);
    }

    $trumbowygRef.on('tbwinit', (event) => {
      $trumbowygRef.parent().addClass('trumbowyg-ready');

      if (onInit) { onInit(event); }
    });

    if (onChange) {
      $trumbowygRef.on('tbwchange', onChange);
    }

    if (onResize) {
      $trumbowygRef.on('tbwresize', onResize);
    }

    if (onPaste) {
      $trumbowygRef.on('tbwpaste', onPaste);
    }

    if (onOpenFullScreen) {
      $trumbowygRef.on('tbwopenfullscreen', onOpenFullScreen);
    }

    if (onCloseFullScreen) {
      $trumbowygRef.on('tbwclosefullscreen', onCloseFullScreen);
    }

    if (onClose) {
      $trumbowygRef.on('tbwclose', onClose);
    }

    $trumbowygRef.trumbowyg('html', value);

    $trumbowygRef.on('tbwblur', () => {
      if (!$trumbowygRef.val()) $trumbowygRef.trumbowyg('empty');
    });
  }, []);

  useEffect(() => {
    $(trumbowygRef.current).trumbowyg(disabled ? 'disable' : 'enable');
  }, [disabled]);

  return (
    <React.Fragment>
      <div className={wrapperClass} onKeyDown={onKeyDown}>
        {label && <label htmlFor={id}>{label}</label>}
        <textarea
          name={id}
          id={id}
          ref={trumbowygRef}
          placeholder={placeholder}
          rows={rows}
          readOnly={readOnly}
          spellCheck={spellCheck}
        />
      </div>
    </React.Fragment>
  );
};

export default Trumbowyg;
